import { h, ComponentChildren, JSX } from 'preact'
import classNames from 'classnames'

interface Props {
  newStyle?: boolean,
  isValid?: boolean,
  children: ComponentChildren
}

const Pill = ({ newStyle = false, isValid = true, children }: Props): JSX.Element => {
  let baseClass = 'preact-pill'
  if (newStyle) baseClass = `${baseClass}-new`
  const classes = classNames(
    baseClass,
    !isValid && 'invalid'
  )

  return <div class={classes}>{children}</div>
}

export default Pill
